module.exports = __webpack_public_path__ + "static/media/conf-app0.f5c1d33e.png";